import Query from '../Query';

export const setMapBounds = (minLat, minLong, maxLat, maxLong) => ({
  type: "SET_MAP_BOUNDS",
  bounds: [[minLat, minLong], [maxLat, maxLong]]
})

export const viewpointChange = (viewpoint) => ({
  type: "VIEWPOINT_CHANGE",
  viewpoint
})

export const receivePublicData = (data) => ({
  type: 'RECEIVE_PUBLIC_DATA',
  data: data
})

export const initializePublicCarveOuts = () => ({
  type: "INIT_PUBLIC_CARVE_OUTS"
})

export const fetchPublicData = () => dispatch => {
  dispatch(setBusyText("Loading data."))
  return Query.search('/api/public_data').then( (data) => {
    if(data instanceof Error || !data.success) {
      dispatch({ type: 'ERROR', message: 'Could not retrieve records from the database.'})
    } else {
      if(data.success){
        dispatch(receivePublicData(data))
        // dispatch(initializePublicCarveOuts())
      } else {
        console.log(data.error)
        dispatch({ type: 'ERROR', message: "Error: " + data.error})
      }
    }
  }).catch(error => {
    console.log(error)
    dispatch({ type: 'ERROR', message: 'Error processing data.'})
  })
}

export const setBusyText = (text) => ({
  type: 'SET_BUSY_TEXT',
  text
})

export const showLoading = () => ({
  type: 'SHOW_LOADING'
})

export const hideLoading = () => ({
  type: 'HIDE_LOADING'
})

export const clearErrorMessage = () => ({
  type: "CLEAR_ERROR_MESSAGE"
})

export const screenResize = () => ({
  type: 'SCREEN_RESIZE'
})



// WEBPACK FOOTER //
// ./src/actions/public.js